import AccountabilityWeight from './AccountabilityWeight.container';

export default AccountabilityWeight;
